import { render } from "./ProductAnalysisSoilConsulting.vue?vue&type=template&id=3be2c7fb"
import script from "./ProductAnalysisSoilConsulting.vue?vue&type=script&lang=js"
export * from "./ProductAnalysisSoilConsulting.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__